import axios from 'axios';
import getEnvVars from '../../env';
import { V1_LOAD_CATEGORIES, V1_LOAD_LEADERS, V1_LOAD_OVERALL_METRICS, V1_LOAD_TIMERANGES, V1_UPDATE_LEADER, V1_UPDATE_METRIC_FILTER } from './types';
const { ANALYTICS_SVC_API } = getEnvVars()
export const analytics_getLeaders = (category_id:string, timerange_id:string, offset:number, viewer_id?:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${ANALYTICS_SVC_API}/v1/leaders/category/${category_id}?timerange_id=${timerange_id}&offset=${offset}&player_id=${viewer_id}`)
            dispatch({ type: V1_LOAD_LEADERS, offset, leaders:resp.data.leaders, timerange:resp.data.timerange, category:resp.data.category })
        } catch (e) {
            console.log(e)
        }
    }
}


export const analytics_getCategories = () => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${ANALYTICS_SVC_API}/v1/leaders/categories/all?status=active`)
            dispatch({ type: V1_LOAD_CATEGORIES, categories: resp.data.categories })
            dispatch({ type: V1_LOAD_TIMERANGES, time_ranges: resp.data.time_ranges })

        } catch (e) {
            console.log(e)
        }
    }
}


export const analytics_getLeadersByPlayerId = (player_id:string, pinned?:boolean) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.get(`${ANALYTICS_SVC_API}/v1/leaders/player/${player_id}?pinned=${pinned}`)
            dispatch({ type: V1_LOAD_CATEGORIES, categories: resp.data.categories })
            dispatch({ type: V1_LOAD_TIMERANGES, time_ranges: resp.data.time_ranges })
            dispatch({ type: V1_LOAD_LEADERS, offset:0, leaders:resp.data.leaders })
        } catch (e) {
            console.log(e)
        }
    }
}

export const analytics_pinLeader = (leader_id:string) => {
    return async(dispatch:any) => {
        try {
            const resp = await axios.post(`${ANALYTICS_SVC_API}/v1/leaders/leader/pin`, { leader_id })
            dispatch({ type:V1_UPDATE_LEADER, leader:resp.data.leader })
        } catch (e) {
            console.log(e)
        }
    }
}

export type FilterType = { data_level:string, range:{start_time:any, end_time:any}, market_type:string, active_filter:string }
export const analytics_getMetricsByFilter = (filter:FilterType) => {
    return async (dispatch:any) => {
        try {

            let resp = await axios.post(`${ANALYTICS_SVC_API}/metrics`, { filter })
            if(resp.data.metrics_data){
                dispatch({ type: V1_LOAD_OVERALL_METRICS, metrics_data: resp.data.metrics_data, order_ids:resp.data.order_ids??[], competitions:resp.data.competitions??[], squares:resp.data.squares??[], filter })
            }
        } catch (e) {
            console.log(e)
        }
    }
}

export const analytics_updateFilter = (filter:FilterType) => {
    return (dispatch:any) => {
        dispatch({ type:V1_UPDATE_METRIC_FILTER, filter })
    } 
}